import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
const testimonials2 = [{
  initials: 'CR',
  text: 'El Mapa de Tiempos me salvó la vida. Mis milanesas salen perfectas todas las veces.',
  author: 'Cecilia R.',
  city: 'Mendoza'
}, {
  initials: 'SC',
  text: 'El Planificador fue lo que necesitaba. Ya no pienso qué cocinar. Todo resuelto.',
  author: 'Sofía C.',
  city: 'La Plata'
}, {
  initials: 'MV',
  text: 'Dejé de pedir delivery. Con el Meal Prep tengo la semana resuelta desde el domingo.',
  author: 'Mónica V.',
  city: 'Tucumán'
}, {
  initials: 'JL',
  text: 'Tenía la freidora guardada hace 6 meses. Con el AirPack la uso todos los días.',
  author: 'Jorge L.',
  city: 'Rosario'
}];
const faqs = [{
  q: '¿Sirve para cualquier modelo de freidora?',
  a: 'Sí. El Tomo 6 incluye tabla de ajuste para los modelos más vendidos en Argentina.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Por email en menos de 5 minutos después del pago.'
}, {
  q: '¿Qué lo diferencia de buscar en Google?',
  a: 'Todo está calibrado para ingredientes, cortes y freidoras argentinas reales. No son recetas genéricas traducidas.'
}, {
  q: '¿Necesito saber cocinar?',
  a: 'No. Si podés seguir instrucciones simples, podés hacer cualquier receta del AirPack.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, 100% del dinero de vuelta. Sin preguntas.'
}];
export function Trust() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-cream relative" data-id="element-247">
      <div className="max-w-5xl mx-auto px-4" data-id="element-248">
        {/* Testimonials 2 */}
        <div className="mb-24" data-id="element-249">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-12 flex items-center justify-center gap-2" data-id="element-250">
            <span className="text-red-500" data-id="element-251">❤️</span> MÁS HOGARES QUE YA LO
            TIENEN
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-252">
            {testimonials2.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex flex-col gap-3 p-5 rounded-xl bg-white border border-sand shadow-sm" data-id="element-253">
                <div className="flex items-center gap-3 mb-2" data-id="element-254">
                  <div className="w-8 h-8 rounded-full bg-charcoal/5 text-charcoal flex items-center justify-center font-bold text-xs" data-id="element-255">
                    {t.initials}
                  </div>
                  <div className="flex text-amber-400" data-id="element-256">
                    {[...Array(5)].map((_, j) => <Star key={j} size={12} fill="currentColor" data-id="element-257" />)}
                  </div>
                </div>
                <p className="text-charcoal/80 text-sm font-medium italic flex-grow" data-id="element-258">
                  "{t.text}"
                </p>
                <p className="text-xs text-charcoal/50 font-semibold uppercase tracking-wide" data-id="element-259">
                  — {t.author}, {t.city}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-white border-2 border-charcoal rounded-2xl p-8 md:p-12 text-center shadow-editorial mb-24" data-id="element-260">
          <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6 border border-sand" data-id="element-261">
            <ShieldCheck size={32} className="text-charcoal" data-id="element-262" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-4" data-id="element-263">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-charcoal/80 text-lg leading-relaxed max-w-xl mx-auto" data-id="element-264">
            Abrís los tomos. Los usás en tu cocina. Si en 7 días no es lo que
            esperabas: devolución del 100%. Sin formularios. Sin drama.
            <span className="block mt-4 text-sm font-bold text-charcoal/50 uppercase tracking-widest" data-id="element-265">
              Tasa de devoluciones: menos del 1%.
            </span>
          </p>
        </motion.div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto" data-id="element-266">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-10 flex items-center justify-center gap-2" data-id="element-267">
            <span className="text-charcoal/40" data-id="element-268">❓</span> LO QUE MÁS NOS
            PREGUNTAN
          </h2>
          <div className="space-y-4" data-id="element-269">
            {faqs.map((faq, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white border border-sand rounded-xl overflow-hidden" data-id="element-270">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-271">
                  <span className="font-bold text-charcoal pr-4" data-id="element-272">{faq.q}</span>
                  <motion.div animate={{
                rotate: openFaq === i ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-273">
                    <ChevronDown size={20} className="text-charcoal/40" data-id="element-274" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-275">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-276">
                      <div className="p-5 pt-0 text-charcoal/70 text-sm leading-relaxed border-t border-sand/30 mt-2" data-id="element-277">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}